import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_DASHBOARD, ROUTE_GOVCRM_CONTACTS } from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';

const Contacts = React.lazy(() => import('./Contacts'));

const isDevOrTest = ['dev', 'test'].includes(process.env.REACT_APP_ENVIRONMENT);

export default function GovCrm() {
  if (!isDevOrTest) {
    return <Redirect to={ROUTE_DASHBOARD.path} />;
  }

  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_GOVCRM_CONTACTS.path}>
          <Contacts />
        </Route>
        <Redirect exact path="/*" to={ROUTE_GOVCRM_CONTACTS.path} />
      </Switch>
    </Suspense>
  );
}
